import Bidrag from "./Bidrag";

export default Bidrag;
